<template lang="pug">
.dawn-select-list.form-group(:class='{ "invalid": error }')
  label(v-if='fieldLabel') {{ fieldLabel }}
    em.optional(v-if='!required && !hideOptional') &nbsp;- optional
  ed-input-tooltip(v-if='helptipBody && error'
                  :helptipHeader='helptipHeader'
                  :helptipBody='helptipBody'
                  :errorTip='error'
                  :class='{ "error-message": error }'
                  )
  .description(v-if='$slots.description')
    em
      slot(name='description')
  label(v-if='emptyFieldLabel') &nbsp;
  .search
    ed-input.pull-left.inline(:placeholder='t("Search")'
      v-model='search'
      @input='debounceSearching(true)'
      search
      :ref="'input'"
    )
  .tabs.pull-right
    a.tab(:class='{ active: isShowAll }' @click.prevent='showAll') {{ $t("Show All") }}
    a.tab(:class='{ active: isSelected }' @click.prevent='showSelected') {{ $t("Selected") }} ({{ selectedCount }})
  .body-wrapper
    .body.ghost(:endpoint='endpoint')
      .list.all(v-if='isShowAll' xendpoint='endpoint')
        .info(v-if='!filteredList.length && !pending') No results
        ed-checkbox(:value='filteredList' @input='updateModel' @click='setModel')
        .info.loading.list(v-if='pending') Loading...
      .list.selected(v-if='isSelected')
        .info(v-if='!selectedFilteredList.length') No results
        ed-checkbox(remove-only :value='selectedFilteredList' @click='setModel')
</template>

<script>

import debounce from 'lodash/debounce'
// import throttle from 'lodash/throttle'
import PerfectScrollbar from 'perfect-scrollbar'
import { i18n } from '@/lang/lang'

const SEARCH_DEBOUNCE = 300
const PAGE_SIZE = 20

export default {
  name: 'ed-select-list',
  props: {
    fieldLabel: String,
    description: String,
    searchable: Boolean,
    emptyFieldLabel: Boolean,
    hideOptional: Boolean,
    readonly: Boolean,
    required: Boolean,
    value: Array,
    endpoint: String,
    trackBy: {
      type: String,
      default: 'key'
    },
    label: {
      type: String,
      default: 'label'
    },
    pageSize: {
      type: Number,
      default: PAGE_SIZE
    },
    params: {},
    helptipHeader: String,
    helptipBody: String,
    error: Boolean
  },
  computed: {
    filteredList() {
      this.updatePs()
      return this.options.filter(item => item.label.toLowerCase().includes(this.search.toLowerCase()))
    },
    selectedList() {
      return this.internalValue.filter(item => item.status)
    },
    selectedFilteredList() {
      this.updatePs()
      return this.selectedList.filter(item => item.label.toLowerCase().includes(this.search.toLowerCase()))
    },
    selectedCount() {
      return this.selectedList.length
    }
  },
  data() {
    return {
      search: '',
      offset: 0,
      pending: false,
      isShowAll: true,
      isSelected: false,
      minChars: 2,
      options: [],
      internalValue: this.value.map(item => ({
        key: item[this.trackBy],
        label: item[this.label] || '[no name]',
        status: true,
        isDisabled: item.IsDisabled
      }))
    }
  },
  methods: {
    t: (key) => i18n.t(key),
    updateModel(e) {
      // this.$emit('input', e)
    },
    setModel(e) {
      e.status
        ? this.internalValue.push(e)
        : this.internalValue.splice(this.internalValue.findIndex(item => item.key === e.key), 1)

      //
      this.options = this.options.map(item => ({
        ...item,
        status: this.internalValue.filter(i => i.key === item.key).length > 0
      }))
      this.$emit('select', e)
      this.$emit('input', this.internalValue.map(item => item.key))
    },
    showAll() {
      this.isShowAll = true
      this.isSelected = false
      this.updatePs()
    },
    showSelected() {
      this.isSelected = true
      this.isShowAll = false
      this.updatePs()
    },
    updatePs() {
      this.$nextTick(() => {
        this.ps.update()
      })
    },

    debounceSearching: debounce(function (reset) {
      if (typeof this.minChars === 'number') {
        this.search.length >= this.minChars && this.asyncSearch(this.search, reset ? 0 : undefined)

        if (this.search === '') {
          this.options = []
          this.asyncSearch('', 0, this.pageSize, false, true)
        }
      } else {
        //
      }
    }, SEARCH_DEBOUNCE),

    async asyncSearch(query, offset, size, scrolling, reset) {
      if (this.pending && reset !== true) return

      this.pending = true
      let result = await this.api.forms.post(this.endpoint, {
        search: { value: query },
        start: typeof offset !== 'undefined' ? offset : this.offset,
        length: size || this.pageSize,
        params: this.params
      })
      if (result && result.data && result.data.Data) {
        if (!result.data.Data.length) {
          this.pending = false
          return
        }

        if (result.data.Data[0] && this.options.findIndex(item => item.key === result.data.Data[0][this.trackBy]) > -1) {
          this.options = []
        }

        this.options = this.options.concat(result.data.Data.map(item => ({
          key: item[this.trackBy],
          label: item[this.label] || '[no name]',
          status: this.internalValue.filter(option => option.key === item[this.trackBy]).length > 0,
          isDisabled: item.IsDisabled
        }))) || this.options
      }
      this.pending = false

      if (scrolling) {
        this.offset += this.pageSize
      }

      this.updatePs()
    },

    loadMore(e) {
      if (this.ps.reach.y === 'end') {
        this.asyncSearch(this.search, this.offset, this.pageSize, true)
      }
    }
  },
  created() {
    this.asyncSearch('', 0, this.pageSize, true)
    this.internalValue && this.internalValue.length > 0 && this.$emit('input', this.internalValue.map(item => item.key))
  },
  mounted() {
    const viewport = this.$el.querySelector('.body-wrapper')

    this.ps = new PerfectScrollbar(viewport, {
      minScrollbarLength: 20,
      mouseWheelSpeed: 30,
      wheelPropagation: false
    })

    viewport.addEventListener('scroll', this.loadMore)
  },
  beforeDestroy() {
    const viewport = this.$el.querySelector('.body-wrapper')
    viewport.removeEventListener('scroll', this.loadMore)
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

$line-height: 2.5em;
$visible-lines: 4.5;

.dawn-select-list {
  position: relative;
  &.form-group {
    &.invalid {
      .body-wrapper{
        border-width: 1px;
        @include theme {
        border-color: v(urgent-01);
        box-shadow: 0px 0px 0px 1px v(urgent-01);
        }
      }
    }
  }

  .body-wrapper {
    max-height: $visible-lines * ($line-height - 0.3em);
    overflow: auto;
    width: 100%;
    position: relative;
    @include theme {
      border: 1px solid v(background);
      box-shadow: inset 0 -3px 5px -2px rgba(0, 0, 0, 0.2);
    }
    >>> .ps__rail-y {
      & {
        background: none;
        .ps__thumb-y {
          @include theme {
            background: v(ink);
          }
        }
      }
    }
  }

  .search.search.search {
    >>> .form-control[search], .form-control[search]:focus {
      padding-bottom: 5px;
      border-width: 1px;
      border-style: solid;
      @include theme {
        border-color: v(background);
      }
      + .search-icon {
        font-size: $font-size-xsmall;
      }
    }
  }
}

.tabs {
  text-align: right;
  margin-bottom: 0.5em;

  .tab.tab.tab {
    display: inline-block;
    padding: 0 0.5em;
    cursor: pointer;
    text-decoration: none;
    font-weight: $font-weight-normal;
    @include theme {
      color: v(border);
    }

    &.active {
      font-weight: $font-weight-bold;
      @include theme {
        color: v(ink);
      }
    }
  }

  .tab + .tab {
    border-left: 1px solid #ccc;
  }
}

.body {
  clear: both;

  .form-group {
    margin: 0;
  }
  .search, .info {
    line-height: 1.8em;
    >>> .form-control[search] {
      padding-bottom: 2px;
      border-width: 1px;
    }
  }
  .list {
    font-size: $font-size-xsmall;
    >>> .form-check, .info {
      padding: 0.1em 0.5em;
      line-height: $line-height;
      @include theme {
        border-bottom: 1px solid v(background-light);
      }

      .form-check-label {
        margin: 0;
      }
    }
    >>> .form-check:hover {
      @include theme {
        background: v(background-light);
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/core/components/edSelectList/index.vue